import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { UncontrolledPopover, PopoverBody, PopoverHeader } from 'reactstrap';
const WhatsThis = ({
  text,
  title: _title = 'What\'s this?'
}) => {
  const [id] = useState(`id-${uuid()}`);
  const styles = {
    cursor: 'help',
    outline: 0
  };
  const shortTitle = typeof text === 'string' ? kebabCase(text.substring(0, 10)) : 'whatsthis';
  const className = `fas fa-info-circle ${shortTitle}`;
  return /*#__PURE__*/React.createElement("i", {
    className: className,
    style: styles,
    id: id,
    role: "button",
    tabIndex: 0,
    onKeyDown: () => {}
  }, /*#__PURE__*/React.createElement(UncontrolledPopover, {
    trigger: "legacy",
    placement: "top",
    target: id
  }, /*#__PURE__*/React.createElement(PopoverHeader, null, _title), /*#__PURE__*/React.createElement(PopoverBody, {
    style: {
      padding: 5,
      textAlign: 'center'
    }
  }, text)));
};
WhatsThis.propTypes = {
  title: PropTypes.string,
  text: PropTypes.node.isRequired
};
export default WhatsThis;